import MPCStore from "./MPCStore";
import Module from "../module";
import OptionStore from "./OptionStore";
import { BUS_I } from "./idx";

const OPFStore = {
  data: {
    opf: {
      bus: [],
      gen: [],
      branch: [],
      dcline: []
    },
    output: "",
    err: ""
  },
  methods: {
    getOPF() {
      return OPFStore.data.opf;
    },
    setOPF(opf) {
      if (!opf) opf = {};
      if (!opf.hasOwnProperty("bus")) opf.bus = [];
      if (!opf.hasOwnProperty("gen")) opf.gen = [];
      if (!opf.hasOwnProperty("branch")) opf.branch = [];
      OPFStore.data.opf = opf;
    },

    getOutput() {
      return OPFStore.data.output;
    },
    setOutput(output) {
      OPFStore.data.output = output;
    },

    error(err = null) {
      if (err === null) return OPFStore.data.err;
      OPFStore.data.err = err;
    },

    success(success = null) {
      if (success === null) {
        return OPFStore.data.opf.success !== false;
      }
      OPFStore.data.opf.success = success;
    },

    getBuses() {
      if (!OPFStore.data.opf.hasOwnProperty("bus")) {
        OPFStore.data.opf.bus = [];
      }
      return OPFStore.data.opf.bus;
    },
    getBus(idx) {
      return OPFStore.methods.getBuses()[idx];
    },
    findBusIdx(n) {
      for (let [index, bus] of OPFStore.methods.getBuses().entries()) {
        if (bus[BUS_I] === +n) return index;
      }
      return -1;
    },

    getGens() {
      if (!OPFStore.data.opf.hasOwnProperty("gen")) {
        OPFStore.data.opf.gen = [];
      }
      return OPFStore.data.opf.gen;
    },
    getGen(idx) {
      return OPFStore.methods.getGens()[idx];
    },

    getBranches() {
      if (!OPFStore.data.opf.hasOwnProperty("branch")) {
        OPFStore.data.opf.branch = [];
      }
      return OPFStore.data.opf.branch;
    },
    getBranch(idx) {
      return OPFStore.methods.getBranches()[idx];
    },

    getDCLines() {
      if (!OPFStore.data.opf.hasOwnProperty("dcline")) {
        OPFStore.data.opf.dcline = [];
      }
      return OPFStore.data.opf.dcline;
    },
    getDCLine(idx) {
      return OPFStore.methods.getDCLines()[idx];
    },

    runOPF() {
      if (!Module.data.ready) return;
      OPFStore.methods.error("");
      OPFStore.methods.setOutput("");
      let mpc = MPCStore.methods.getMPC();
      let mpopt = OptionStore.methods.getOptions();
      return Module.methods
        .runOPF(mpc, mpopt)
        .catch(err => {
          OPFStore.methods.error(err.message);
          OPFStore.methods.setOutput(err.output);
        })
        .then(opf => {
          if (opf) {
            OPFStore.methods.setOutput(opf.output);
            OPFStore.methods.setOPF(opf.retval);
          }
        });
    }
  }
};

export default OPFStore;
